import { RouteProps, Route, Redirect } from 'react-router';

import { GuardFunction } from '../guards/guard';
import { useLoginRedirect } from '../login/Login.context';

type ProtectedRouteProps = RouteProps & {
  guards?: Array<GuardFunction>;

  // Will use to redirect when all guards failed to activate
  // By default it will redirect to `/login`
  redirectTo?: string;
};

function ProtectedRoute(props: ProtectedRouteProps) {
  const { guards = [] } = props;
  const isAllowed = guards.some(guard => guard().canActivate());
  const { getLoginRoute } = useLoginRedirect();
  if (!isAllowed) {
    return <Redirect to={getLoginRoute()} />;
  }
  return <Route {...props} />;
}

export default ProtectedRoute;
